import React, { createContext, useContext, type ReactNode } from "react";

import { usePerformRequest } from "../../lib/usePerformRequest";
import { Endpoints } from "../../lib/endpoints";
import { IUserProps } from "../../types/User";

type DashboardContextValue = {
  profile?: IUserProps;
  isLoading: boolean;
  status: number | string;
  reloadProfile: () => Promise<void>;
};

const DashboardContext = createContext<DashboardContextValue | undefined>(
  undefined
);

export function DashboardProvider({ children }: { children: ReactNode }) {
  const { route, method } = Endpoints.GetUserProfile();
  const { data, isLoading, status, reloadData } = usePerformRequest<{
    user: IUserProps;
  }>({
    route,
    method,
  });

  const value: DashboardContextValue = {
    profile: data?.user,
    isLoading,
    status,
    reloadProfile: reloadData,
  };

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboardContext() {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error(
      "useDashboardContext must be used within a DashboardProvider"
    );
  }

  return context;
}
